import { useCallback } from 'react';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';

export const PULSE_MESSAGE_ID = 'menu-item-pulse';
export const LOZENGE_MESSAGE_ID = 'menu-item-lozenge';
export const INELIGIBLE_FOR_CONFLUENCE_ACCESS_ID = 'ineligible-for-confluence-access';

const sessionStorage = createSessionStorageProvider('cjn_project_pages_on_userid');
const localStorage = createLocalStorageProvider('cjn_project_pages_on_userid');

export const useIsEligibleForSpotlight = (): [() => [boolean, boolean, boolean]] => {
	const checkIfSpotlightOrLozengeShown = useCallback((): [boolean, boolean, boolean] => {
		const canShowPulse = canShowProperty(PULSE_MESSAGE_ID);
		const canShowLozenge = canShowProperty(LOZENGE_MESSAGE_ID);
		const isIneligibleForAccess = hasPropertyInLocalStore(INELIGIBLE_FOR_CONFLUENCE_ACCESS_ID);

		return [canShowPulse, canShowLozenge, isIneligibleForAccess];
	}, []);

	return [checkIfSpotlightOrLozengeShown];
};
const canShowProperty = (propertyKey: string): boolean =>
	!sessionStorage.get(propertyKey) && !localStorage.get(propertyKey);

const hasPropertyInLocalStore = (propertyKey: string): boolean =>
	sessionStorage.get(propertyKey) || localStorage.get(propertyKey);

export const useUserSpotlightProperty = (propertyKey: string): [() => void] => {
	const markAsPropertySeen = useCallback(() => {
		localStorage.set(propertyKey, true);
		sessionStorage.set(propertyKey, true);
	}, [propertyKey]);
	return [markAsPropertySeen];
};
